// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-Ygupt","loading":"index-loading-2pj9p"};